// IELTS Mock 6 — Academic Speaking
// Same shape as IELTS_DATA_SPEAKING in ../IeltsSpeaking.js.
const IELTS_MOCK6_SPEAKING = {
  title: "Academic Speaking Practice Test 6",
  parts: [
    {
      id: "part1",
      title: "Part 1: Introduction & Interview (4-5 min)",
      questions: [
        "Let's talk about time. Are you usually early, on time or late for appointments?",
        "Do you think people in your country value punctuality? Why?",
        "Let's talk about maps. How often do you use maps?",
        "Do you think people are losing the ability to find their way without technology?",
        "Is there a place you have never visited that you would like to explore?"
      ]
    },
    {
      id: "part2",
      title: "Part 2: Long Turn (Cue Card) (3-4 min)",
      prompt: "Describe a belief or opinion you held strongly that later changed. You should say: What the belief was, Why you held it, What caused you to change your mind, and explain how changing your mind affected you.",
      preparationTime: 60,
      speakingTime: 120
    },
    {
      id: "part3",
      title: "Part 3: Discussion (4-5 min)",
      questions: [
        "Why do you think people find it so difficult to admit that they were wrong?",
        "To what extent should the public trust experts, given that experts sometimes disagree or make mistakes?",
        "Some people say that the internet encourages people to seek out only the opinions they already agree with. How far do you accept this?",
        "Should schools teach children how to evaluate evidence, or is that the responsibility of the media and society as a whole?",
        "In the future, do you think it will become easier or harder for societies to agree on what is true?"
      ]
    }
  ]
};

export default IELTS_MOCK6_SPEAKING;
